import type { Results } from '@shared/models/unit.model';
import {
  C2_TRANSPORT_DISTANCE_KM,
  C2_TRUCK_ENERGY_MJ_PER_TONKM,
  C_PHASE_GWP_DIESEL_PER_MJ,
} from './c-phase.constants';

const KG_PER_TON = 1000;

/**
 * C2 emissions per ton of demolition waste (kg CO2e/ton):
 * `diesel_gwp (kg CO2e/MJ) * distance (km) * truck energy (MJ/tonkm)`.
 */
export const C2_CO2E_PER_TON =
  C_PHASE_GWP_DIESEL_PER_MJ *
  C2_TRANSPORT_DISTANCE_KM *
  C2_TRUCK_ENERGY_MJ_PER_TONKM;

/**
 * C2 transport of demolition waste for a single product's mass (IVL, DEV-3325).
 *
 * Linear in mass, so the per-product values sum correctly into the building total.
 * Coverage (täckningsgrad) is applied later by the rollup, so it is not divided here.
 */
export const mapResultsByC2 = (results: Results): Results => {
  const mass = results.kg ?? 0;
  if (!mass) return results;

  const co2e = (mass / KG_PER_TON) * C2_CO2E_PER_TON;
  if (!co2e) return results;

  return { ...results, co2e_C2: (results.co2e_C2 ?? 0) + co2e };
};
